/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PiePiece
 */
export interface PiePiece {
    /**
     * 
     * @type {string}
     * @memberof PiePiece
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof PiePiece
     */
    to?: string;
    /**
     * 
     * @type {number}
     * @memberof PiePiece
     */
    count?: number;
}

/**
 * Check if a given object implements the PiePiece interface.
 */
export function instanceOfPiePiece(value: object): value is PiePiece {
    return true;
}

export function PiePieceFromJSON(json: any): PiePiece {
    return PiePieceFromJSONTyped(json, false);
}

export function PiePieceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PiePiece {
    if (json == null) {
        return json;
    }
    return {
        
        'from': json['from'] == null ? undefined : json['from'],
        'to': json['to'] == null ? undefined : json['to'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function PiePieceToJSON(json: any): PiePiece {
    return PiePieceToJSONTyped(json, false);
}

export function PiePieceToJSONTyped(value?: PiePiece | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': value['from'],
        'to': value['to'],
        'count': value['count'],
    };
}

